module.exports = __webpack_public_path__ + "static/media/remote-work-man.74996533.svg";